import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import './Image.css';
import { Typography } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '90%',
  width: 800,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 3,
};

export default function Image(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const thumbPath = '/images/gallery/thumb/' + props.image;
  const fullPath = '/images/gallery/full/' + props.image;

  return (
    <div>
      <Button onClick={handleOpen}>
        <img src={thumbPath} alt={props.title} className="image" />
      </Button>
      <Typography align="center"><em>{props.title}</em></Typography>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Button sx={{ mb: 2 }} onClick={handleClose}>Close</Button>
          <img src={fullPath} alt={props.title} className="modal-image" />
          <Typography align="center"><em>{props.title}</em></Typography>
        </Box>
      </Modal>
    </div>
  );
}
